import VueRouter from 'vue-router'
import MixinResize from '../mixin-resize'
import AppHeader from '../app-header'
import AppFooter from '../app-footer'
import AppCart from '../app-cart'
import AppCookies from '../app-cookies'
import AppSubscribe from '../app-subscribe'
import AppMenu from '../app-menu'
import content, { getPage, getProductBySlug } from '../../content.js'
import Shopify from '../utils/Shopify'

import PageHome from '../page-home'
import PageProduct from '../page-product'
import PageStory from '../page-story'
import PageMission from '../page-mission'
import PageEating from '../page-eating'
import PageProducts from '../page-products'
import PagePolicy from '../page-policy'
import PageTerms from '../page-terms'
import Page404 from '../page-404'
import { scrollTo } from '../utils/easeScrollTo'
// import RGPD from '../utils/RGPD'

const PAGE_HOME = getPage('home')
const PAGE_STORY = getPage('story')
const PAGE_MISSION = getPage('mission')
const PAGE_EATING = getPage('eating')
const PAGE_PRODUCTS = getPage('products')

const shopify = new Shopify()
// const rgpd = new RGPD()

const router = new VueRouter({
    mode: 'history',
    routes: content.pages.map(data => ({ path: data.path, meta: data}))
})

export default {

    router,

    mixins: [
        MixinResize
    ],

    components:
    {
        AppHeader,
        AppFooter,
        AppCart,
        AppCookies,
        AppSubscribe,
        AppMenu,
        PageHome,
        PageProduct,
        Page404,
        PageProducts,
        PageStory,
        PageMission,
        PageEating,
        PagePolicy,
        PageTerms
    },

    data()
    {
        return {
            currentPage: null,
            params: {},
            headerGreen: true,
            isCartOpen: false,
            footer: true,
            isCookiesBannerOpen: false, // rgpd.isNothing()
            isSubscribeOpen: false,
            isMenuOpen: false
        }
    },

    watch:
    {
        $route: 'onRouteChange'
    },

    created()
    {
        this.eventHub.$on('cart:open', () => this.isCartOpen = true)
        this.eventHub.$on('cart:close', () => this.isCartOpen = false)

        this.eventHub.$on('subscribe:open', () => this.isSubscribeOpen = true)
        this.eventHub.$on('subscribe:close', () => this.isSubscribeOpen = false)

        this.eventHub.$on('menu:open', () => this.isMenuOpen = true)
        this.eventHub.$on('menu:close', () => this.isMenuOpen = false)
        this.eventHub.$on('menu:toggle', () => this.isMenuOpen = !this.isMenuOpen)
        
        // console.log('RGPD:', rgpd)
    },

    mounted()
    {
        this.onRouteChange(this.$route)
        shopify.onLoading.add(this.onLoadChange)
    },

    methods:
    {
        onLoadChange(isLoading)
        {
            if (isLoading)
            {
                document.body.classList.add('is-loading')
            }
            else
            {
                document.body.classList.remove('is-loading')
            }
        },

        getMainPages()
        {
            return [
                PAGE_STORY,
                PAGE_MISSION,
                PAGE_EATING
            ]
        },

        onResized(width, height)
        {
            this.winWidth = width
            this.winHeight = height
        },

        onRouteChange(to)
        {
            // Meta data (SEO)
            const meta = {}
            if (to.meta.name === 'product') {
                const product = getProductBySlug(to.params.slug)
                meta.title = product.meta.title
                meta.description = product.meta.description
            } else {
                meta.title = to.meta.meta.title
                meta.description = to.meta.meta.description
            }
            this.setMeta(meta.title, meta.description)

            // Activate page
            this.params = JSON.parse(JSON.stringify(to.params))
            this.pageSee++
            this.currentPage = to.meta.name
            this.headerGreen = to.meta.headerGreen
            this.footer = to.meta.footer
            scrollTo(0)

            this.eventHub.$emit('menu:close')

            // Google Analytics
            // try
            // {
            //     const gtag = window.gtag
            //     if (gtag)
            //     {
            //         gtag('config', 'UA-60417875-23', {
            //             page_title : to.meta.title,
            //             page_path: to.path
            //         })
            //     }
            // }
            // catch (error)
            // {
            //     console.error('Google Analytics error:', error)
            // }
        },

        setMeta(title = 'Zero Days Off - Food', description = '')
        {
            document.title = title
            const descriptionTag = document.querySelector('meta[name=description]')
            if (descriptionTag)
            {
                descriptionTag.setAttribute('content', description)
            }
        }
    }
}
